// Canales de venta, para evaluar por qué medio se vende más.
export const CANALES = [
  { valor: 'Tienda física', icono: '🏪' },
  { valor: 'Instagram', icono: '📷' },
  { valor: 'WhatsApp', icono: '💬' },
  { valor: 'Facebook', icono: '👍' },
  { valor: 'Página web', icono: '🌐' },
];

export const CANAL_DEFECTO = 'Tienda física';

export const iconoCanal = (valor) => CANALES.find((c) => c.valor === valor)?.icono || '🛒';
